import React,{useEffect, useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useGoogleAnalytics from '../../CustomHooks/useGoogleAnalytics';
import AdvancedSettingBox from './AdvancedSettingBox';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';

export default function AdvancedSettings (props) {
    const [translateGui] = useGuiTranslations();
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const setGAPath = useGoogleAnalytics();

    useEffect(
        () => {
            //GA
            //setGAPath('/AdvancedSettings');

            //Breadcrumb
            globalContext.dispatchMethod(
                {
                    type: 'SET_MENU_LOCATION',
                    value: {
                        a: 8,
                        b: 13,
                    },
                }
            )
        }, []
    )

    return (
        <div className={classes.root}>
            <AdvancedSettingBox
            icon="language"
            name={capitalizeFirstLetter(translateGui(81))}
            description={capitalizeFirstLetter(translateGui(82))}
            url="/Settings/MultiLanguage"
            />
            <AdvancedSettingBox
            icon="card_membership"
            name={capitalizeFirstLetter(translateGui(83))}
            description={capitalizeFirstLetter(translateGui(84))}
            url="/Subscription"
            />
            <AdvancedSettingBox
            icon="color_lens"
            name={capitalizeFirstLetter(translateGui(85))}
            description={capitalizeFirstLetter(translateGui(86))}
            url="/ColorsAndFonts"
            />
            <AdvancedSettingBox
            icon="notification_important"
            name={capitalizeFirstLetter(translateGui(124))}
            description={capitalizeFirstLetter(translateGui(125))}
            url="/settings/push-notification"
            />
            <div className={classes.version} >
                version: 20201220.1322
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    root: {
        width: '90%',
        display: 'flex',
        flexWrap: 'wrap',    
        paddingTop: '20px',
        
    },
    version:{
        position: 'fixed',
        bottom: 0,
        right:0,
    }
    
});